const auditPlatform = {
  SHIPPER: 1,
  TRANSPORTER: 2,
  CONSIGNEE: 3,
  ERP: 4,
  FREIGHT_FORWARDER: 5,
  CHA: 6,
  TRACK_AND_TRACE: 7,
  PACKING: 8,
  SYSTEM: 9,
  TRANSPORTER_INTEGRATION: 10,
  LMS: 11,
  COURIER: 12,
  DRIVER: 13
};

const auditChannel = {
  WEB: 1,
  MOBILE: 2,
  SYSTEM: 3,
};

const auditType = {
  PAYMENT_CHARGE_UPDATED: 1,
  PAYMENT_ATTACHMENTS: 2,
  PAYMENT_COMMENTS: 3,
  INVOICE_GENERATED: 4,
  INVOICE_REMARK: 5,
  INVOICE_CHECKED: 6,
  INVOICE_APPROVED: 7,
  INVOICE_REJECTED: 8,
  INVOICE_RE_SUBMITTED: 9,
  INVOICE_RETURN: 10,
  INDENT_CREATED: 11,
  INDENT_ASSIGNED: 12,
  VEHICLE_NUMBER_UPDATE: 13,
  ENABLE_SIM_TRACKING: 14,
  INSPECTION: 15,
  TRUCK_IN: 16,
  MANUAL_MATERIAL_INVOICE_UPLOAD: 17,
  AUTO_MATERIAL_INVOICE_UPLOAD: 18,
  START_LOADING: 19,
  END_LOADING: 20,
  MANUAL_TRUCK_OUT: 21,
  TRUCK_OUT_BY_MATERIAL_INVOICE_UPLOAD: 22,
  LR_NUMBER_UPDATE: 23,
  LR_IMAGE_UPLOAD: 24,
  BULK_DELIVER: 25,
  DELIVER: 26,
  GRN: 27,
  GRN_BULK_UPLOAD: 28,
  EPOD: 29,
  RETRIGGER_EPOD: 30,
  APPROVE_EPOD: 31,
  REPORTED_AT: 32,
  APPROVE_OTP: 33,
  APPROVE_ORDER_OTP: 34,
  FREIGHT_FORWARDER_ACCEPT_INDENT: 35,
  FREIGHT_FORWARDER_REJECT_INDENT: 36,
  FREIGHT_FORWARDER_UPDATE_CONTAINER: 37,
  FREIGHT_FORWARDER_GET_INDENT: 38,
  INDENT_AUTO_MARKED_DELIVERED_VIA_COURIER_AUTO_DELIVERED: 39,
  ACCEPT_TERMS_CONDITIONS: 40,
  TRUCK_IN_TRUCK_OUT: 41,
  EMPTY_CONTAINER_RETURNED: 42,
  UPDATE_LINE_SEAL_NUMBER: 43,
  TRUCK_OUT: 44,
  CONSIGNEE_REPORTED: 45,
  CONSIGNEE_RELEASED: 46,
  RELEASE_AT: 47,
  RESEND_OTP: 48,
  UPDATE_BID_SLOT_SETTINGS: 49,
  UPDATE_DETENTION_SETTINGS: 50,
  UPDATE_DIESEL_PEG_SETTINGS: 51,
  UPDATE_DOCUMENT_SETTINGS: 52,
  UPDATE_HOLIDAY_SETTINGS: 53,
  UPDATE_LR_SETTINGS: 54,
  UPDATE_MATERIAL_HEADERS_SETTINGS: 55,
  UPDATE_NOTIFICATION_SETTINGS: 56,
  UPDATE_OPEN_INDENT_SETTINGS: 57,
  UPDATE_OPTIMA_SETTINGS: 58,
  UPDATE_AUTO_RUN_SETTINGS: 59,
  UPDATE_DEPOT_AUTO_RUN_SETTINGS: 60,
  UPDATE_SDCD_SETTINGS: 61,
  UPDATE_SLA_SETTINGS: 62,
  UPDATE_SLOT_SETTINGS: 63,
  UPDATE_UNIT_SETTINGS: 64,
  WALLET_ATTACHMENTS: 65,
  UPDATE_USER_ROLE: 66,
  UPDATE_USER_STATUS: 67,
  OPEN_FREIGHT: 68,
  MATERIAL_INVOICE_OTP_GENERATED: 69,
  START_PACKING: 66,
  EDIT_PACKING: 67,
  ADD_CARTON: 68,
  DELETE_CARTON: 69,
  MULTIPLY_CARTON: 70,
  EDIT_CARTON: 71,
  SCAN_ITEM: 72,
  QUICK_ADD: 73,
  MINUS_ITEM: 74,
  SERIAL_SCAN: 75,
  SERIAL_DELETE: 76,
  SAVE_CARTON: 77,
  CLOSE_CARTON: 78,
  EXCEPTED_FLAG: 79,
  BACKORDER: 80,
  UPDATE_META: 81,
  ROUTE_TO_TRAFFIC: 82,
  CREATE_SHIPMENT: 83,
  PACKER_RELEASE: 84,
  REPACK: 85,
  SUPERVISOR_RELEASE: 86,
  PACK_REASSIGN: 87,
  TRAFFIC_REASSIGN: 88,
  LPN_SCAN: 89,
  SHIPMETHOD_CHANGE: 90,
  CARRIER_CHANGE: 91,
  CONSOLIDATED: 92,
  DECONSOLIDATED: 93,
  REMOVE_DELIVERY: 94,
  CANCEL_INDENT: 95,
  INDENT_STATUS_UPDATE: 96,
  LOGIN: 97,
  LOGOUT: 98,
  COMMENT_ATTACHMENTS: 99,
  UPDATE_WALLET_SETTINGS: 100,
  INVOICE_ATTACHMENT: 101,
  UPDATE_BILL_DISCOUNT_SETTINGS: 102,
  EDIT_ARRIVED_AT_TIMESTAMP: 103,
  EDIT_REPORTED_AT_TIMESTAMP: 104,
  EDIT_DISPATCHED_AT_TIMESTAMP: 105,
  EDIT_CONSIGNEE_REPORTED_AT_TIMESTAMP: 106,
  EDIT_RELEASED_AT_TIMESTAMP: 107,
  WALLET_PAYV2: 108,
  INSPECTION_AT_DESTINATION: 109,
  UPDATE_CENTRAL_HO_SETTINGS: 110,
  MARTERIAL_INVOICE_GRN: 111,
  UPDATE_CONSIGNEE_BULK_UPLOAD: 112,
  UPDATE_CONSIGNEE_ERP: 113,
  UPDATE_CONSIGNEE_UI: 114,
  CREATE_CONSIGNEE_UI: 115,
  LOCATION_MILESTONE: 116,
  MARK_AS_DISPATCH: 117,
  UPDATE_TRANSPORTER_BULK_UPLOAD: 118,
  UPDATE_TRANSPORTER_ERP: 119,
  UPDATE_TRANSPORTER_UI: 120,
  CREATE_TRANSPORTER_UI: 121,
  BULK_MANUAL_MATERIAL_INVOICE_UPLOAD: 122,
  UPDATE_WALLET_CONFIG: 123,
  UPDATE_FREIGHT_BILL_CONFIG: 124,
  UPDATE_USER: 125,
  CREATE_USER: 126,
  RETRY_FREIGHT_PROVIOSION: 127,
  RETRY_FREIGHT_INVOICE: 128,
  UPDATE_CONTRACT: 129,
  EXTRA_DROP_OFF_BULK_UPLOAD: 130,
  COST_CENTER_BULK_UPLOAD: 131,
  CONTRACT_VEHICLE_EXCLUDE_UPLOAD: 132,
  DEDICATED_TRUCK_UPLOAD: 133,
  DEPOT_BULK_UPLOAD: 134,
  ERP_DRIVER_BULK_UPLOAD: 135,
  LOCATION_BULK_UPLOAD: 136,
  ERP_MATERIAL_BULK_UPLOAD: 137,
  MATERIAL_CATEGORY_BULK_UPLOAD: 138,
  MATERIAL_BULK_UPLOAD: 139,
  DETENTION_BULK_UPLOAD: 140,
  LOADING_UNLOADING_BULK_UPLOAD: 141,
  PURCHASE_ORDER_UPLOAD: 142,
  RATE_MATRIX_UPLOAD: 143,
  SLA_CHARGES_UPLOAD: 144,
  TRANSIT_BULK_UPLOAD: 145,
  BASE_DIESEL_RATE_UPLOAD: 146,
  USER_BULK_UPLOAD: 147,
  VEHICLE_UPLOAD: 148,
  CLEARING_HOUSE_AGENT_UPLOAD: 149,
  CONTAINER_BULK_UPLOAD: 150,
  PORTS_BULK_UPLOAD: 151,
  VEHICLE_DETAILS_BULK_UPLOAD: 152,
  BILL_DISCOUNT_BULK_UPLOAD: 153,
  CONSIGNEE_BULK_UPLOAD: 154,
  DIRECT_DISPATCH_UPLOAD: 155,
  ERP_EPOD_BULK: 156,
  ERP_MODIFIED_PICKLIST: 157,
  CONTRACT_TSD_BULK_UPLOAD: 158,
  GATE_BULK_UPLOAD: 159,
  DESTINATION_CHARGES_UPLOAD: 160,
  EXPIRED_PURCHASE_ORDERS_BULK_UPLOAD: 161,
  FUTURE_PURCHASE_ORDERS_BULK_UPLOAD: 162,
  CREATE_PORT_UI: 163,
  CREATE_MATERIAL_UI: 164,
  CREATE_MATERIAL_CATEGORY_UI: 165,
  CREATE_LOCATION: 166,
  CREATE_VENDOR_DEPOT_UI: 167,
  CREATE_DEPOT_UI: 168,
  CREATE_DEDICATED_TRUCK_UI: 169,
  CREATE_BUCC_UI: 170,
  CREATE_VEHICLE_UI: 171,
  CREATE_CHA_UI: 172,
  CREATE_GATE_UI: 173,
  CREATE_CONTAINER_UI: 174,
  FREIGHT_FORWARDER_UI: 175,
  BILL_DISCOUNT_UI: 176,
  ADD_BLACK_LISTED_VEHICLE: 177,
  ADD_BLACK_LISTED_DRIVER: 178,
  TRANSPORTER_BULK_UPLOAD_ERP: 179,
  TRANSPORTER_BULK_UPLOAD: 180,
  UPDATE_INVOICE_CUSTOM_FIELDS_SETTING: 181,
  ERP_TRUCK_OUT: 182,
  ERP_TRUCK_IN: 183,
  ACTIVITY_TIME_BULK_UPLOAD: 184,
  AUTO_SWITCH: 185,
  VEHICLE_UTILIZATION_APPROVAL:186,
  INSPECTION_REJECTION: 187,
  INSPECTION_ACCEPTED: 188,
  SOURCE_CHARGES_UPLOAD: 189,
  UPDATE_AUTO_INDENT_SETTINGS: 190,
  DELIVERY_PENDING: 191,
  MATERIAL_CATEGORY_ADDITIONAL_BULK_UPLOAD: 192,
  MATERIAL_INVOICE_WITH_LR: 193,
  MATERIAL_INVOICE_WITH_PACKAGE_AND_LR: 194,
  REDIRECTION_MASTER_BULK_UPLOAD: 195,
  USER_ACTIVITY: 196,
  UPDATE_DEPOT_NAME : 197,
  UPDATE_DEPOT_REFERENCE_ID : 198,
  UPDATE_DEPOT_PINCODE : 199,
  UPDATE_DEPOT_ADDRESS : 200,
  UPDATE_DEPOT_CITY : 201,
  UPDATE_DEPOT_GSTIN : 202,
  UPDATE_GATE_NAME : 203,
  UPDATE_GATE_REFERENCE_ID : 204,
  UPDATE_GATE_PINCODE : 205,
  ASSOCIATED_DEPOT_CHANGE: 206,
  BILL_DISCOUNT_UPDATE: 207,
  VEHICLE_UPDATE: 208,
  PAY_ANOMALY: 209,
  PAYMENT_GENERATION: 210,
  UPDATE_PAY_ANOMALY_SETTINGS: 211,
  RFQ_APPROVED: 212,
  RFQ_REJECTED: 213,
  BASE_FREIGHT_APPROVED: 214,
  BASE_FREIGHT_REJECTED: 215,
  CHANGE_PASSWORD:216,
  UPDATE_INDENT: 217,
  RETURN_MANAGEMENT: 218,
  RE_INDENT: 219,
  WALLET_SETTLED: 220,
  VEHICLE_STATUS_CHANGE: 221,
  EPOD_APPROVED: 222,
  EPOD_REJECTED: 223,
  AUTO_DELIVER_FROM_DISPATCH: 224,
  FREIGHT_CHANGE_REQUESTED: 225,
  APPROVED_FREIGHT_CHANGE_REQUEST: 226,
  REJECTED_FREIGHT_CHANGE_REQUEST: 227,
  OPTIMA_MATERIAL_UPLOAD: 228,
  TRUCK_WEIGHT_UPDATE: 229,
  TRUCK_TARE_WEIGHT_UPDATE : 230,
  TRUCK_GROSS_WEIGHT_UPDATE : 231,
  LR_ATTACHMENT_REJECTONS: 232,
  TRUCK_CHANGE_REQUEST: 233,
  EPOD_SUBMISSION: 234,
  LR_ATTACHMENT_REJECTONS: 235,
  STOP_DIESEL_PEG: 236,
};

const packingAuditType = {
  CONSOLIDATE_DELIVERY: 1,
  PALLETIZED_CARTONS: 2,
  CREATE_SHIPMENT: 3,
  ROUTE_TO_TRAFFIC: 4,
  BACK_ORDER: 5,
  MIS_SCANNED: 6,
  CANCEL_DELIVERY: 7,
  HANDOVER_COMPLETE: 8,
  CARTON_MULTIPLIER: 9,
  PRINT_DOCUMENT: 10,
  RE_OPENED_DELIVERY: 11,
  RE_SHIPPED_DELIVERY: 12,
  RE_TRIGGERED_DELIVERY: 13,
  CARTON_AUDIT: 14,
  CREATE_DELIVERY: 15,
  MOVED_TO_DOCK: 16,
  MOVE_BACK_TO_INDENTED: 17,
  DELETE_CARTON: 18,
  RELEASE_DELIVERY: 19,
  GENERATE_DOCUMENTS: 20,
  RE_ASSIGNED_BENCH: 21,
  INDENT_CANCEL: 22,
  INDENT_DELIVERED: 23,
  RE_PACK: 24,
  START_PACKING: 25,
  EDIT_PACKING: 26,
  DE_CONSOLIDATION: 27,
  CREATE_TASK: 28,
  COMPLETE_TASK: 29,
  CANCEL_TASK: 30,
  MANUAL_TASK_CREATION: 31,
  TASK_CANCEL: 32,
  INVENTORY_UPDATE: 33,
  UPDATE_PALLET: 34,
  CARTON_DROP_OFF: 35,
  BACK_FUSH: 36,
  ASSIGN_TASK: 37,
  RE_SHIPPED_DELIVERY_PROCESSING: 38,
  RE_SHIP_ERROR: 39,
  INVOICE_CUSTOM: 40,
};

const DepotMasterCheck = {
  name: {
    type: auditType.UPDATE_DEPOT_NAME,
    message: "Depot name changed from fromName to toName",
  },
  reference_id: {
    type: auditType.UPDATE_DEPOT_REFERENCE_ID,
    message: "Depot reference_id changed from fromName to toName",
  },
  pincode: {
    type: auditType.UPDATE_DEPOT_PINCODE,
    message: "Depot pincode changed from fromName to toName",
  },
  address: {
    type: auditType.UPDATE_DEPOT_ADDRESS,
    message: "Depot address changed from fromName to toName",
  },
  city: {
    type: auditType.UPDATE_DEPOT_CITY,
    message: "Depot city changed from fromName to toName",
  },
  gstn_no: {
    type: auditType.UPDATE_DEPOT_GSTIN,
    message: "Depot gstin changed from fromName to toName",
  },
};

const DepotGateCheck = {
  name: {
    type: auditType.UPDATE_GATE_NAME,
    message: "Gate name changed from fromName to toName",
  },
  reference_id: {
    type: auditType.UPDATE_GATE_REFERENCE_ID,
    message: "Gate reference_id changed from fromName to toName",
  },
  pincode: {
    type: auditType.UPDATE_GATE_PINCODE,
    message: "Gate pincode changed from fromName to toName",
  }
};

module.exports = {
  auditPlatform,
  auditChannel,
  auditType,
  packingAuditType,
  DepotMasterCheck,
  DepotGateCheck
};
